"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuickBooksSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "#2CA01C" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.3367 7.33379H16.0033C18.5807 7.33379 20.67 9.42313 20.67 12.0005C20.67 14.5777 18.5807 16.6671 16.0033 16.6671H12.668V4.13379C13.6252 4.13379 14.4013 4.90979 14.4013 5.86712V14.9337H16.0033C17.6208 14.9337 18.9367 13.6179 18.9367 12.0005C18.9367 10.383 17.6208 9.06712 16.0033 9.06712H15.3367V7.33379ZM8.00651 16.6663C5.42917 16.6663 3.33984 14.577 3.33984 11.9997C3.33984 9.4224 5.42917 7.33301 8.00651 7.33301H11.3419V19.8663C10.3846 19.8663 9.60854 19.0902 9.60854 18.133V9.06634H8.00651C6.38907 9.06634 5.07318 10.3822 5.07318 11.9997C5.07318 13.6171 6.38907 14.933 8.00651 14.933H8.67318V16.6663H8.00651Z", fill: "white" }));
}
function QuickBooks(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuickBooksSvg, Object.assign({}, svgProps)));
}
exports.default = QuickBooks;
//# sourceMappingURL=QuickBooks.js.map